import { AxiosHeaders } from 'axios'
import * as R from 'ramda'

export const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined' && !R.isNil(window.apiBaseUrl)) {
    return window.apiBaseUrl
  }
  return 'http://localhost:8080'
}

const backendURI = '/api/backend'

export const apiRouteUtils = {
  baseConfigUrl: { url: '/api/backend/baseconfig' },
  masterData: { url: `${backendURI}/masterdata` },
  customerData: { url: `${backendURI}/customer` },
  sfDataWithOutConfig: {
    url: `${backendURI}/salesforce/opportunities-without-config`,
    headers: new AxiosHeaders({ 'Content-Type': 'application/json' })
  },
  opportunity: {
    url: `${backendURI}/opportunity`
  },
  opportunitySearch: {
    url: `${backendURI}/opportunity/search`
  },
  opportunityShare: {
    url: `${backendURI}/opportunity/share`,
    headers: new AxiosHeaders({ 'Content-Type': 'application/json' })
  },
  salesforceClearCache: {
    url: `${backendURI}/salesforce/clear-cache`,
    headers: new AxiosHeaders({ 'Content-Type': 'application/json' })
  },
  activeSession: {
    url: '/api/sse'
  },
  userSettings: {
    url: `${backendURI}/settings`
  },
  saveOffer: {
    url: `${backendURI}/opportunity/saveOffer`,
    timeout: 5 * 60 * 1000,
    contentType: 'application/json'
  },
  customerSavedOffer: {
    url: `${backendURI}/customer/customerSavedOffer`,
    contentType: 'application/json'
  },
  equipmentCreation: {
    url: `${backendURI}/equipment-creation`,
    headers: new AxiosHeaders({ 'Content-Type': 'application/json' })
  },
  gendocGetContractPDF: {
    url: `${backendURI}/gendoc/get-contract-pdf`,
    contentType: 'application/json'
  },
  createGendocXml: {
    url: `${backendURI}/gendoc/xml`,
    contentType: 'application/json'
  },
  recreateGendocDocuments: {
    url: `${backendURI}/gendoc/recreate`,
    contentType: 'application/json'
  },
  sendContractPdf: {
    url: `${backendURI}/gendoc/send-contract-pdf`,
    contentType: 'application/json'
  },
  activateVersion: {
    url: `${backendURI}/opportunity/activate`,
    contentType: 'application/json'
  },
  finalizeOffer: {
    url: `${backendURI}/opportunity/finalize`,
    contentType: 'application/json'
  },
  discountApprovalStatus: {
    url: `${backendURI}/opportunity/discount-approval-status`,
    contentType: 'application/json'
  },
  escalationBillingPlan: {
    url: `${backendURI}/escalation`,
    contentType: 'application/json'
  }
}
